import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type HtmlSnippet {\n    id: Int\n    content: String\n    style: String\n    javascript: String\n  }\n\n  type Query {\n    htmlSnippet(id: Int, idKey: String): HtmlSnippet\n  }\n"])));
export var resolvers = {
  Query: {
    htmlSnippet: function () {
      var _htmlSnippet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var id, idKey, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref.id, idKey = _ref.idKey;
                dataSources = _ref2.dataSources;
                _context.next = 4;
                return dataSources.htmlSnippet.getHtmlSnippet(id, idKey);

              case 4:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function htmlSnippet(_x, _x2, _x3) {
        return _htmlSnippet.apply(this, arguments);
      }

      return htmlSnippet;
    }()
  }
};